import { ArrowRight, ShieldCheck } from "lucide-react";
import { BRAND, PRODUCT_MESSAGES } from "../../config/site";
import { ROUTES } from "../../config/routes";
import { CtaLink } from "../common/CtaLink";
import { WindshieldScene } from "../brand/WindshieldScene";

const HeroCopy = () => (
  <div className="max-w-xl">
    <p className="label-mono inline-flex items-center gap-2 text-[#00E676] reveal">
      <ShieldCheck className="h-3.5 w-3.5" aria-hidden="true" /> Private vehicle contact
    </p>
    <h1 className="mt-6 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl reveal" style={{ animationDelay: "80ms" }}>
      Your Vehicle.<br /><span className="text-[#FF5500]">Always</span> Reachable.
    </h1>
    <p className="mt-6 text-base leading-relaxed text-slate-400 md:text-lg reveal" style={{ animationDelay: "160ms" }}>
      CARLINK gives your vehicle a secure digital identity, allowing people to contact you when your vehicle needs your attention — without exposing your personal phone number.
    </p>
    <div className="mt-9 flex flex-col gap-3 sm:flex-row reveal" style={{ animationDelay: "240ms" }}>
      <CtaLink to={ROUTES.PRICING} testId="hero-cta-primary" className="justify-center">Get CARLINK <ArrowRight className="h-4 w-4" /></CtaLink>
      <CtaLink to={ROUTES.HOW_IT_WORKS} variant="ghost" testId="hero-cta-secondary" className="justify-center">See How It Works</CtaLink>
    </div>
  </div>
);

export const HeroSection = () => (
  <section className="relative overflow-hidden" aria-label={BRAND.tagline}>
    <div className="grid-bg absolute inset-0 opacity-50" aria-hidden="true" />
    <div className="container-x relative grid items-center gap-12 py-16 sm:py-20 lg:grid-cols-[1fr_1.1fr] lg:py-28">
      <HeroCopy />
      <div className="reveal" style={{ animationDelay: "200ms" }}>
        <WindshieldScene
          src="/images/hero-windshield.jpg"
          alt="Front windshield of a dark sedan with a CARLINK QR sticker in the upper corner of the glass"
          testId="hero-sticker-mockup"
          stickerClass="right-[30%] top-[25%] scale-[0.8] origin-top-right sm:scale-100"
          size="xs"
          className="aspect-[4/3] shadow-[0_40px_120px_-40px_rgba(255,85,0,0.35)]"
        >
          <span className="label-mono absolute bottom-4 left-4 rounded-md border border-white/10 bg-black/50 px-3 py-1.5 text-slate-300 backdrop-blur">Front windshield · demo sticker</span>
        </WindshieldScene>
      </div>
    </div>
    <div className="relative border-y border-white/5 bg-[#0F111A]/60">
      <ul data-testid="hero-product-message" className="container-x grid grid-cols-2 gap-y-4 py-6 md:grid-cols-4">
        {PRODUCT_MESSAGES.map((m, i) => (
          <li key={m} className="flex items-center gap-3 font-display text-sm font-semibold uppercase tracking-wide text-slate-200 md:text-base">
            <span className="font-mono text-xs text-[#FF5500]">0{i + 1}</span>{m}
          </li>
        ))}
      </ul>
    </div>
  </section>
);
